import React from 'react';
import PropTypes from 'prop-types';
import scrollIntoView from 'scroll-into-view-if-needed';
import classNames from 'classnames';

import StoreDetails from './store-details';
import screenAndStyle from '../_utils/screen-and-style';

class StoreList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.setFirstLocationAsDefault = this.setFirstLocationAsDefault.bind(this);
    this.selected = this.selected.bind(this);

    this.selectedStoreRef = null;
    this.state = {
      defaultLocationIndex: -1
    };
  }

  componentDidUpdate(prevProps) {
    const { currentStoreId } = this.props;

    if (currentStoreId !== prevProps.currentStoreId) {
      this.scrollSelectedIntoView();
    }
  }

  setFirstLocationAsDefault() {
    this.setState({ defaultLocationIndex: 0 });
  }

  scrollSelectedIntoView() {
    if (!this.selectedStoreRef) return;

    // Use native scrollIntoView if supported
    if ('scrollBehavior' in document.documentElement.style) {
      this.selectedStoreRef.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      return;
    }

    scrollIntoView(this.selectedStoreRef, { block: 'center' });
  }

  removeDefaultLocationIndex() {
    this.setState({ defaultLocationIndex: -1 });
  }

  selected(el) {
    const { defaultLocationIndex } = this.state;
    this.selectedStoreRef = el

    if (defaultLocationIndex === 0) {
      el.click();
      this.removeDefaultLocationIndex()
    }
  }

  render() {
    const { locations, currentStoreId } = this.props;
    const { defaultLocationIndex } = this.state;

    if (!locations.length) {
      return null;
    }

    const isMobile = screenAndStyle.isMobileBrowser();

    return (
      <div id='store-list' className='store-list' role='region' aria-live='polite'>
        <h6>Nearby Photo Centers</h6>
        <ol>
          {
            locations.map((location, index) => {
              const isSelected = currentStoreId === location.id || defaultLocationIndex === index;

              return (
                <li
                  key={location.id}
                  ref={isSelected ? this.selected : null}
                  className={classNames({ 'selected': isSelected })}
                  onClick={this.props.onStoreChanged.bind(this, location)}>

                  <StoreDetails
                    listNumber={index + 1}
                    location={location}
                    showInfo={isSelected && isMobile}
                    showMiles />
                </li>
              );
            })
          }
        </ol>
      </div>
    );
  }
}

StoreList.propTypes = {
  currentStoreId: PropTypes.string,
  locations: PropTypes.arrayOf(PropTypes.object),
};

StoreList.defaultProps = {
  currentStoreId: undefined,
  locations: [],
};

export default StoreList;
